import type { ReactNode } from "react";

type BadgeProps = {
  children: ReactNode;
  variant?: "gold" | "dark" | "light";
  className?: string;
};

export const Badge = ({ children, variant = "gold", className }: BadgeProps) => {
  const classes = ["sg-badge", `sg-badge--${variant}`, className]
    .filter(Boolean)
    .join(" ");

  return <span className={classes}>{children}</span>;
};
